import { __assign } from "tslib";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ddt from '@wix/da-ddt';
import { BiDataHook, ReferralType } from '@wix/da-bi/pkg/constants';
import { PureBiData } from '@wix/da-bi/pkg/events';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import { SubscriptionPurchaseFTUEContext } from '../../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import SubscribeToUnlockTooltip from '../../_partials/SubscribeToUnlockTooltip';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarButton from '../../_partials/items/ActionBarButton';
import { getDeviationFreeDownload } from './permissions';
var logger = ddt.createLogger('downloadbutton');
var FreeDownloadButton = function (_a) {
    var deviation = _a.deviation, className = _a.className, onDownload = _a.onDownload, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    var t = useTranslation().t;
    var _b = useRestrictToLoggedIn(), isLoggedIn = _b.isLoggedIn, restrictToLoggedIn = _b.restrictToLoggedIn;
    // when the user first purchases a subscription, open the tooltip and highlight the icon
    var isButtonHighlighted = useContext(SubscriptionPurchaseFTUEContext) === 'tooltips';
    logger.log('FreeDownloadButton, deviation:', deviation);
    var _c = getDeviationFreeDownload(deviation), download = _c.download, permission = _c.permission;
    logger.log({ download: download, permission: permission });
    if (!download) {
        return null;
    }
    var wrapperProps = {
        className: className,
        forceVisibleTooltip: isButtonHighlighted,
    };
    var buttonProps = {
        biData: PureBiData({
            evid: 350,
            ispaiddownload: 0,
            deviationid: deviation.deviationId,
        }),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
    };
    // send anon to sisu for both free and premium downloads
    if (!isLoggedIn) {
        var tooltip_1 = t('actionbar.download.mustLogIn');
        return (React.createElement(ActionBarItemWrapper, __assign({}, wrapperProps, { tooltip: tooltip_1 }),
            React.createElement(ActionBarButton, __assign({}, buttonProps, { "aria-label": tooltip_1, onClick: restrictToLoggedIn(ReferralType.ANON_DOWNLOAD) }),
                React.createElement(ActionBarIcon, { isActive: isButtonHighlighted, icon: DownloadIcon }))));
    }
    // in-tier, un-subbed free downloads are blocked with a special popup
    var subPreventsDownload = permission === 'needs_subscription' ||
        permission === 'blocked_by_subscription';
    if (subPreventsDownload) {
        logger.log('free download blocked by tier', deviation.tier);
        return (React.createElement(SubscribeToUnlockTooltip, { className: className, deviation: deviation, forceVisible: isButtonHighlighted },
            React.createElement(ActionBarButton, __assign({}, buttonProps, { disabled: true, "aria-label": t('actionbar.freeDownload') }),
                React.createElement(ActionBarIcon, { isActive: isButtonHighlighted, icon: DownloadIcon }))));
    }
    // here, we know the user is logged in and the special case of
    // free downloads in subscription content is handled, so let them download
    var tooltip = t('actionbar.freeDownload');
    return (React.createElement(ActionBarItemWrapper, __assign({}, wrapperProps, { tooltip: tooltip }),
        React.createElement(ActionBarButton, __assign({}, buttonProps, { href: download.url, target: "_blank", download: true, "aria-label": tooltip, dataHook: BiDataHook.DEVIATION_DOWNLOAD_BUTTON, onClick: download.url ? onDownload : undefined }),
            React.createElement(ActionBarIcon, { isActive: isButtonHighlighted, icon: DownloadIcon }))));
};
FreeDownloadButton.displayName = 'FreeDownloadButton';
export default FreeDownloadButton;
//# sourceMappingURL=FreeDownloadButton.js.map